import Image from "next/image";

export default function AdCard({ image, badge, copy, cta, note, featured }) {
  return (
    <div
      className={`w-[160px] md:w-[180px] xl:w-[210px] 2xl:w-[300px] shrink-0 overflow-hidden rounded-[20px] bg-white ring-1 ring-black/[0.06] ${
        featured
          ? "shadow-[0_30px_60px_-15px_rgba(16,24,40,0.32)]"
          : "shadow-[0_24px_48px_-18px_rgba(16,24,40,0.25)]"
      }`}
    >
      {/* media */}
      <div className="relative h-[80px]  md:h-[100px]  lg:h-[120px] 2xl:h-[140px] w-full">
        <Image
          src={image}
          alt={`${badge} ad creative`}
          fill
          sizes="300px"
          className="object-cover"
        />
        <span className="absolute bottom-3 left-3 rounded-full bg-black/40 px-3 py-1 text-[8px] lg:text-[10px] font-semibold uppercase tracking-[0.08em] text-white backdrop-blur-sm">
          {badge}
        </span>
      </div>

      {/* body */}
      <div className="p-2.5">
        <div className="flex items-center gap-2.5">
          <span className="grid h-4 w-4 md:h-6 md:w-6 place-items-center rounded-full bg-[#0004D2] text-[12px] md:text-[14px] font-semibold text-white">
            I
          </span>
          <div className="leading-tight">
            <p className="text-[10px] md:text-[12px] font-semibold text-[#283245]">
              Imagive Brand
            </p>
            <p className="text-[8px] lg:text-[10px]">
              <span className="text-[#A8A29E]">Sponsored</span> · ↑ Boosted
            </p>
          </div>
        </div>

        <p className="mt-2 text-[10px]  md:text-[11px] leading-[1.4] text-[#292929]">{copy}</p>

        {note ? (
          <div className="mt-2 flex items-center justify-between rounded-[8px] bg-[#F2F3F5] px-1 py-1">
            <span className="truncate w-[120px] text-[8px] md:text-[10px] font-medium text-[#283245]">
              {note}
            </span>
            <button className="shrink-0 rounded-full bg-[#1a1a1a] px-3 py-1 text-[8px] md:text-[10px] font-medium text-white">
              {cta}
            </button>
          </div>
        ) : (
          <div className="mt-4 flex justify-end">
            <button className="rounded-full bg-[#1a1a1a] px-4 py-1 text-[8px] md:text-[10px] font-medium text-white">
              {cta}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
